// eslint-disable-next-line consistent-return
export const clearObject = (items = {}) => {
  const keys = Object.keys(items);
  if (keys.length === 0) return null;
  // eslint-disable-next-line no-param-reassign
  keys.forEach((key) => delete items[key]);
};
